import * as amplitude from "@amplitude/analytics-browser"
let customerExperience = amplitude.createInstance()
let candidateExperience = amplitude.createInstance()
const analytics = () => {
  const pricingRoutes = ["/pricing", "/prices", "/see-pricing"]
  const signupRoutes = ["/signup", "/get-started"]
  const personalChecksRoutes = [
    "/personal-background-checks",
    "/personal-background-check",
    "/lp-personal-education-verification",
    "/lp-personal-signup-cta",
    "/personal-employment-verification",
  ]
  const personalChecksFormIds =
    process.env.GATSBY_PERSONALCHECKS_FORMS.split(",")

  const init = async () => {
    return customerExperience.init(process.env.GATSBY_AMPLITUDE_API_KEY, {
      autocapture: {
        pageViews: true,
        sessions: false,
        formInteractions: false,
        fileDownloads: false,
      },
      instanceName: "customerExperience",
    }).promise
  }

  const initCandidateExperience = async () => {
    return candidateExperience.init(
      process.env.GATSBY_AMPLITUDE_CANDIDATE_EXPERIENCE_KEY,
      {
        autocapture: {
          attribution: true,
          pageViews: true,
          sessions: true,
          formInteractions: false,
          fileDownloads: false,
        },
        instanceName: "candidateExperience",
      },
    ).promise
  }

  const getUserId = () => {
    const userId = customerExperience.getUserId()
    return userId ? userId : null
  }
  const getDeviceId = () => {
    const deviceId = customerExperience.getDeviceId()
    return deviceId ? deviceId : null
  }

  const trackPageView = path => {
    if (pricingRoutes.includes(path)) {
      customerExperience.track(EVENT_TYPES.SELF_SERVE_PRICING_PAGE_VIEW)
    }
    if (signupRoutes.includes(path)) {
      customerExperience.track(EVENT_TYPES.SELF_SERVE_SIGNUP_PAGE_VIEW)
    }
    if (personalChecksRoutes.includes(path)) {
      candidateExperience.track(
        EVENT_TYPES.SELF_SERVE_PERSONAL_CHECKS_PAGE_VIEW,
        {
          "Business Entry Point": "Checkr",
        },
      )
    }
    if (path.includes("/lp-direct-mail")) {
      customerExperience.track(
        EVENT_TYPES.SELF_SERVE_MARKETING_DIRECT_MAIL_PAGE_VIEW,
      )
    }
  }

  const trackButtonClick = (e, path) => {
    const { innerText, className } = e.target
    const srcElement = e.srcElement
    const href = srcElement.getAttribute("href")

    if (personalChecksRoutes.includes(path)) {
      if (
        href !== null &&
        (href.includes("apply.checkr") ||
          href.includes("betterfuture") ||
          href.includes(
            "https://apply.checkr.com/apply/better-future-paywall-enabled/3b870f8a5c921a2dbc304bc4d3e2399f",
          ) ||
          href.includes("personal.checkr.com/checks"))
      ) {
        candidateExperience.track(
          EVENT_TYPES.SELF_SERVE_PERSONAL_CHECKS_PAGE_CTA_CLICKED,
          {
            "Business Entry Point": "Checkr",
          },
        )
        candidateExperience.flush()
      }
    }

    if (href !== null && href.includes("checkr.com/profiles/auth/signup")) {
      candidateExperience.track(
        EVENT_TYPES.PERSONAL_CHECKS_SING_UP_CTA_CLICKED,
        {
          "Business Entry Point": "Checkr",
        },
      )
      candidateExperience.track(EVENT_TYPES.VERIFIED_PROFILES_CTA_CLICKED, {
        "Business Entry Point": "Checkr",
      })
      candidateExperience.flush()
    }

    if (href !== null && href.includes("checkr.com/profiles/auth/signin")) {
      candidateExperience.track(EVENT_TYPES.VERIFIED_PROFILES_CTA_CLICKED, {
        "Business Entry Point": "Checkr",
      })
      candidateExperience.flush()
    }

    if (signupRoutes.includes(path)) {
      if (innerText === "pricing breakdown") {
        customerExperience.track(
          EVENT_TYPES.SELF_SERVE_PRICING_BREAKDOWN_LINK_CLICK,
        )
      } else if (innerText === "Check the status of your background check") {
        customerExperience.track(EVENT_TYPES.SELF_SERVE_CHECK_STATUS_LINK_CLICK)
      } else if (innerText === "Sign in") {
        customerExperience.track(EVENT_TYPES.SELF_SERVE_SIGNUP_LINK_CLICK)
      }
    }

    if (pricingRoutes.includes(path) && typeof className === "string") {
      if (className.includes("basic-plus-plan")) {
        customerExperience.track(
          EVENT_TYPES.SELF_SERVE_PRICING_PAGE_GET_STARTED_CLICK,
          {
            "Get Started Package Type": "Basic+",
          },
        )
      } else if (className.includes("essential-plan")) {
        customerExperience.track(
          EVENT_TYPES.SELF_SERVE_PRICING_PAGE_GET_STARTED_CLICK,
          {
            "Get Started Package Type": "Essential",
          },
        )
      } else if (className.includes("professional-plan")) {
        customerExperience.track(
          EVENT_TYPES.SELF_SERVE_PRICING_PAGE_GET_STARTED_CLICK,
          {
            "Get Started Package Type": "Professional",
          },
        )
      } else if (className.includes("bottomModalCta")) {
        customerExperience.track(
          EVENT_TYPES.SELF_SERVE_PRICING_PAGE_BOTTOM_CTA_CLICK,
        )
      }
    }
    customerExperience.flush()
  }

  const trackFormSubmission = async (formId, values, path, tier) => {
    try {
      const {
        Annual_Volume_of_Checks__c,
        timetofirstcheckMarketo,
        email,
        selfBackgroundCheck,
      } = values

      // Build user attributes object
      const userAttributes = {
        ...(formId && { "Form ID": formId }),
        ...(timetofirstcheckMarketo && {
          "Time To First Order": timetofirstcheckMarketo,
        }),
        ...(Annual_Volume_of_Checks__c && {
          "Annual Volume of Checks": Annual_Volume_of_Checks__c,
          Tier: tier,
        }),
        ...(email && {
          Email: email,
          "lead email": email,
        }),
      }

      // Track general form submission for non-blog paths and perform group identification
      let baseTrackingPromise = Promise.resolve()
      if (!path.includes("blog")) {
        customerExperience.track(
          EVENT_TYPES.GENERAL_FORM_SUBMISSION,
          userAttributes,
        )
      }

      // Determine which specific event to track
      const isPersonalCheck =
        Annual_Volume_of_Checks__c === "1" ||
        selfBackgroundCheck === "true" ||
        personalChecksFormIds.includes(formId)

      const isBusinessCheck =
        ((formId === "1006" || formId === "1388" || formId === "1763") &&
          Annual_Volume_of_Checks__c !== "1") ||
        selfBackgroundCheck === "false"

      // Handle personal background check submissions
      if (isPersonalCheck) {
        candidateExperience.track(
          EVENT_TYPES.SELF_SERVE_SIGNUP_PAGE_PERSONAL_CHECKS_FORM_SUBMISSION,
          {
            "Form ID": formId,
            "Business Entry Point": "Checkr",
          },
        )
      }

      // Handle business background check submissions
      if (isBusinessCheck) {
        let eventType = null

        if (pricingRoutes.includes(path)) {
          eventType = EVENT_TYPES.SELF_SERVE_PRICING_PAGE_COMPLETED
        } else if (
          signupRoutes.includes(path) ||
          selfBackgroundCheck === "false"
        ) {
          eventType = EVENT_TYPES.SELF_SERVE_SIGNUP_PAGE_COMPLETED
        }

        if (eventType) {
          customerExperience.track(eventType, userAttributes)
        }
      }

      // Default case - just flush any pending events
      return Promise.all([baseTrackingPromise]).then(() => {
        customerExperience.flush()
        candidateExperience.flush()
        return Promise.resolve()
      })
    } catch (error) {
      console.error("Error tracking form submission:", error)
      // Return a resolved promise to prevent blocking the form submission flow
      return Promise.resolve()
    }
  }

  return {
    init,
    initCandidateExperience,
    trackPageView,
    trackButtonClick,
    trackFormSubmission,
    getUserId,
    getDeviceId,
  }
}

export { analytics }

const EVENT_TYPES = {
  SELF_SERVE_SIGNUP_PAGE_VIEW:
    "Self-Serve Customer Signup Marketing Signup Page Viewed",
  SELF_SERVE_SIGNUP_PAGE_COMPLETED:
    "Self-Serve Customer Signup Marketing Signup Page Completed",
  SELF_SERVE_PRICING_PAGE_VIEW:
    "Self-Serve Customer Signup Pricing Page Viewed",
  SELF_SERVE_PRICING_PAGE_COMPLETED:
    "Self-Serve Customer Signup Pricing Page Modal Completed",
  SELF_SERVE_PRICING_BREAKDOWN_LINK_CLICK:
    "Self-Serve Customer Signup Marketing Signup Page Price Breakdown Clicked",
  SELF_SERVE_CHECK_STATUS_LINK_CLICK:
    "Self-Serve Customer Signup Marketing Signup Page Check Status Clicked",
  SELF_SERVE_SIGNUP_LINK_CLICK:
    "Self-Serve Customer Signup Marketing Signup Page Sign In Clicked",
  SELF_SERVE_PRICING_PAGE_GET_STARTED_CLICK:
    "Self-Serve Customer Signup Pricing Page Get Started Clicked",
  SELF_SERVE_PRICING_PAGE_BOTTOM_CTA_CLICK:
    "Self-Serve Customer Signup Pricing Page Bottom Sign Up Now Clicked",
  GENERAL_FORM_SUBMISSION: "Self-Serve Marketing Signup Page Completed",
  SELF_SERVE_SIGNUP_PAGE_PERSONAL_CHECKS_FORM_SUBMISSION:
    "Self-Serve Marketing Signup Page - Personal Checks Lead Form Completed",
  SELF_SERVE_PERSONAL_CHECKS_PAGE_VIEW:
    "Self-Serve Marketing Personal Background Check Landing Page Viewed",
  SELF_SERVE_PERSONAL_CHECKS_PAGE_CTA_CLICKED:
    "Self-Serve Marketing Personal Background Check Landing Page CTA Clicked",
  SELF_SERVE_MARKETING_DIRECT_MAIL_PAGE_VIEW:
    "Self-Serve Marketing Direct Mail Landing Page Viewed",
  PERSONAL_CHECKS_SING_UP_CTA_CLICKED: "Profile Signup CTA Clicked",
  VERIFIED_PROFILES_CTA_CLICKED: "Checkr Verified- Claim your profile Clicked",
}
